export default __webpack_public_path__ + "fd5495dca24970b2380d46d69379cdd2.png";